/**
 * Created by denis.gusarov on 12/9/2016.
 */

namespace Factive.Game {

    import List = Factive.Core.Linq.List;
    import Resource = PIXI.loaders.Resource;

    export class Resources {

        public static dragonBonesData: dragonBones.DragonBonesData = null;
        public static dragonBonesDatasDict: Object = {};

        public static dragonBonesTexturesData: dragonBones.TextureAtlasData = null;
        public static dragonBonesTexturesDatasDict: Object = {};

        private static DB_OBJECTS_TO_LOAD: Array<Object> = [];


        public static load: any = (resourcesPath,assetScale,resolve1 = null, reject1 = null) => {
            //console.log("resourcesPath",resourcesPath,assetScale);
            return new Promise(function (resolve, reject) {

                if (PIXI.loader.loading) {
                    return new Promise(function () {
                        PIXI.loader.once("complete", function () {
                            Resources.load(resourcesPath, resolve, reject);
                        });
                    });
                }

                var needLoad = false;

                var dbDataPrefix: string = "dbData";
                var dbTextureDataPrefix: string = "dbTextureData";
                var dbTexturePrefix: string = "dbTexture";
                var postfixLandscape: string = "Landscape";
                var assetName: string;

                assetName = dbDataPrefix + postfixLandscape

                if (!PIXI.loader.resources[assetName]) {
                    needLoad = true;
                    PIXI.loader.add(assetName, resourcesPath + "/assets/images/"+assetScale.toString()+"x/landscape_ske.json");
                }
                assetName = dbTextureDataPrefix + postfixLandscape;
                if (!PIXI.loader.resources[assetName]) {
                    needLoad = true;
                    PIXI.loader.add(assetName, resourcesPath + "/assets/images/"+assetScale.toString()+"x/landscape_tex.json");
                }
                assetName = dbTexturePrefix + postfixLandscape;
                if (!PIXI.loader.resources[assetName]) {
                    needLoad = true;
                    PIXI.loader.add(assetName, resourcesPath + "/assets/images/"+assetScale.toString()+"x/landscape_tex.png");
                }

                let hasErrors = false;

                if (!needLoad) {
                    resolve1 ? resolve1() : resolve();
                    return;
                }

                PIXI.loader.once("complete", (loader: PIXI.loaders.Loader, object: dragonBones.Map<PIXI.loaders.Resource>) => {
                    if (hasErrors) {
                        return;
                    }
                    var keys = Object.keys(object);
                    var l = keys.length;
                    for (var i = 0; i < l; i++) {
                        var key = keys[i];
                        var dbDataKey;
                        var dbTextureDataKey;
                        var dbTextureKey;
                        var postfix;
                        if (key.indexOf(dbTextureDataPrefix) != -1) {
                            dbTextureDataKey = key;
                            postfix = key.replace(dbTextureDataPrefix, "");
                            dbTextureKey = dbTexturePrefix + postfix;



                            if (!Resources.dragonBonesTexturesDatasDict[postfix] && object[dbTextureDataKey].data && object[dbTextureKey].texture) {
                                Resources.dragonBonesTexturesDatasDict[postfix] = dragonBones.PixiFactory.factory.parseTextureAtlasData(object[dbTextureDataKey].data, object[dbTextureKey].texture);
                            }
                        }
                        else if (key.indexOf(dbTexturePrefix) != -1) {
                            dbTextureKey = key;
                            postfix = key.replace(dbTexturePrefix, "");
                            dbTextureDataKey = dbTextureDataPrefix + postfix;

                            if (!Resources.dragonBonesTexturesDatasDict[postfix] && object[dbTextureDataKey].data && object[dbTextureKey].texture) {
                                Resources.dragonBonesTexturesDatasDict[postfix] = dragonBones.PixiFactory.factory.parseTextureAtlasData(object[dbTextureDataKey].data, object[dbTextureKey].texture);
                            }
                        }
                        else if (key.indexOf(dbDataPrefix) != -1) {

                            dbDataKey = key;
                            postfix = key.replace(dbDataPrefix, "");

                            if (!Resources.dragonBonesDatasDict[postfix] && object[dbDataKey].data) {
                                Resources.dragonBonesDatasDict[postfix] = dragonBones.PixiFactory.factory.parseDragonBonesData(object[dbDataKey].data);
                            }

                        }

                    }
                    resolve1 ? resolve1() : resolve();
                });
                PIXI.loader.once("error", (error, loader: PIXI.loaders.Loader, resource: PIXI.loaders.Resource) => {
                    hasErrors = true;
                    reject1 ? reject1(error) : reject(error);
                });
                PIXI.loader.load();
            });
        };

        public static getTextureData(textureName: string, atlasName?: string): dragonBones.TextureData {
            if (atlasName == null || atlasName == undefined) {
                atlasName = "Landscape";
            }
            return Resources.dragonBonesTexturesDatasDict[atlasName].getTexture(textureName);
        }
    }
}



// WEBPACK FOOTER //
// src/typescript/Game/Resources.ts